import React from "react";
import { Box, Divider, Paper } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export const PropertyLoader: React.FC = (props) => (
  <Box
    display="flex"
    flexDirection="column"
    component={Paper}
    marginBottom={3}
    overflow="hidden"
    {...props}
  >
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box p={2}>
        <Skeleton width={24} height={24} variant="circle" animation="wave" />
      </Box>
      <Box py={2} pr={2} flexGrow={1}>
        <Skeleton variant="rect" width="65%" animation="wave" />
      </Box>
    </Box>
    <Divider />
    <Box display="flex" flexDirection="row">
      <Box p={2}>
        <Skeleton width={24} height={24} variant="circle" animation="wave" />
      </Box>
      <Box py={2} pr={2} flexGrow={1} minHeight={160}>
        <Box clone mb={1}>
          <Skeleton variant="rect" height={12} width="28%" animation="wave" />
        </Box>
        <Skeleton variant="rect" height={12} width="23%" animation="wave" />
      </Box>
    </Box>
  </Box>
);
